import { render, staticRenderFns } from "./PartnerTanimla.vue?vue&type=template&id=d6aa26c2&scoped=true&"
import script from "./PartnerTanimla.vue?vue&type=script&lang=js&"
export * from "./PartnerTanimla.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTanimla.vue?vue&type=style&index=0&id=d6aa26c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aa26c2",
  null
  
)

export default component.exports